<template>
  <div class="content">
    <div class="common">
      <div class="download-portal">
        <ul
          class="portal-sort"
          :class="[
            downloadItemCount > 4 ? 'portal-sort-many' : 'portal-sort-few',
            'portal-sort-items-' + downloadItemCount,
          ]"
        >
          <!-- window版本 -->
          <li class="download-item" v-if="newWindow && newWindow.url">
            <div class="download-item__icon">
              <div class="icon-img">
                <img class="" src="../../assets/images/ai-img-w.png" alt="" />
              </div>
            </div>
            <div class="download-item__actions">
              <h3 class="download-item__title">{{ $t("window.title") }}</h3>
              <div class="download-item__btns">
                <p class="bit-link">
                  <a
                    href="javascript:void(0);"
                    class="download-btn"
                    @click="handleDownloadClick(newWindow.url, newWindow.version)"
                  >
                    <img
                      src="../../assets/images/a-img-download1.png"
                      width="20"
                      style="vertical-align: middle; margin-right: 5px"
                    />
                    {{ $t("window.linkOne") }}
                  </a>
                </p>
              </div>
            </div>
            <div class="download-item__version version-item">
              <p class="version-msg">
                {{ $t("window.version") }}: {{ newWindow.version }}
              </p>
              <p class="version-msg">
                {{ $t("window.updateTime") }}:
                {{ newWindow.createTime | formatDate }}
              </p>
              <p class="version-msg">
                {{ $t("window.compatible") }}: Windows7/8/10/11
              </p>
            </div>
          </li>
          <!-- window移动版（仅 app.gpt-mouse.com） -->
          <!-- <li
            class="download-item"
            v-if="
              ['app.gpt-mouse.com', 'www.imouse.shop'].includes(domainName) &&
              newWindowMobile &&
              newWindowMobile.url
            "
          >
            <div class="icon-img">
              <img class="" src="../../assets/images/ai-img-w.png" alt="" />
            </div>
            <div class="download-text">
              <h3>Windows（移动定制版）</h3>
              <p class="bit-link">
                <a
                  href="javascript:void(0);"
                  class="download-btn"
                  @click="
                    handleDownloadClick(newWindowMobile.url, newWindowMobile.version)
                  "
                >
                  <img
                    src="../../assets/images/a-img-download1.png"
                    width="20"
                    style="vertical-align: middle; margin-right: 5px"
                  />
                  {{ $t("window.linkOne") }}
                </a>
              </p>
            </div>
            <div class="version-item">
              <p class="version-msg">
                {{ $t("window.version") }}: {{ newWindowMobile.version }}
              </p>
              <p class="version-msg">
                {{ $t("window.updateTime") }}:
                {{ newWindowMobile.updateTime | formatDate }}
              </p>
              <p class="version-msg">
                {{ $t("window.compatible") }}: Windows7/8/10/11
              </p>
            </div>
          </li> -->
          <!-- MAC版本 -->
          <li class="download-item" v-if="newMac && newMac.url">
            <div class="download-item__icon">
              <div class="icon-img">
                <img class="" src="../../assets/images/ai-img-apple.png" alt="" />
              </div>
            </div>
            <div class="download-item__actions">
              <h3 class="download-item__title">{{ $t("mac.title") }}</h3>
              <div class="download-item__btns">
                <p class="bit-link">
                  <a
                    href="javascript:void(0);"
                    v-if="
                      ['www', 'shadow', 'imouse', 'eweadn', 'dario'].includes(
                        brandSubdomain,
                      )
                    "
                    class="download-btn"
                    @click="handleDownloadClick(newMac.url, newMac.version)"
                  >
                    <img
                      src="../../assets/images/a-img-download1.png"
                      width="20"
                      style="vertical-align: middle; margin-right: 5px"
                    />
                    {{ $t("mac.linkOne") }}
                  </a>
                  <a
                    href="javascript:void(0);"
                    class="download-btn"
                    v-else
                    @click="handleDownloadClick(newMac.url, newMac.version)"
                  >
                    <img
                      src="../../assets/images/a-img-download1.png"
                      width="20"
                      style="vertical-align: middle; margin-right: 5px"
                    />
                    {{ $t("mac.linkOne") }}
                  </a>
                </p>
              </div>
            </div>
            <div class="download-item__version version-item">
              <p class="version-msg">
                {{ $t("mac.version") }}: {{ newMac.version }}
              </p>
              <p class="version-msg">
                {{ $t("mac.updateTime") }}: {{ newMac.createTime | formatDate }}
              </p>
              <p class="version-msg">
                {{ $t("mac.compatible") }}: Mac 10.15以上
              </p>
            </div>
          </li>
          <!-- 安卓 -->
          <li
            class="download-item"
            v-if="
              ['cloudeer', 'lf-zjzs'].includes(brandSubdomain) &&
              newAndroid &&
              newAndroid.url
            "
          >
            <div class="download-item__icon">
              <div
                class="icon-img img-over img-out"
                v-show="androidIcon"
                @mouseover="overAndroidCode"
              >
                <img
                  class=""
                  src="../../assets/images/ai-img-android.png"
                  alt=""
                />
              </div>
              <div
                class="android-code img-over img-out"
                v-if="androidCode"
                @mouseout="outAndroidCode"
              >
                <vue-qr
                  :logoSrc="logoIcon"
                  :text="newAndroid.url"
                  :size="110"
                ></vue-qr>
              </div>
            </div>
            <div class="download-item__actions">
              <h3 class="download-item__title">{{ $t("android.title") }}</h3>
              <div class="download-item__btns">
                <p class="bit-link">
                  <a
                    href="javascript:void(0);"
                    class="download-btn"
                    @click="
                      handleDownloadClick(newAndroid.url, newAndroid.version)
                    "
                  >
                    <img
                      src="../../assets/images/a-img-download1.png"
                      width="20"
                      style="vertical-align: middle; margin-right: 5px"
                    />
                    {{ $t("android.linkOne") }}
                  </a>
                </p>
              </div>
            </div>
            <div class="download-item__version version-item">
              <p class="version-msg">
                {{ $t("android.version") }}: {{ newAndroid.version }}
              </p>
              <p class="version-msg">
                {{ $t("android.updateTime") }}:
                {{ newAndroid.createTime | formatDate }}
              </p>
              <p class="version-msg">{{ $t("android.compatible") }}: Android</p>
            </div>
          </li>
          <!-- iTWS 安卓（仅 miceai.aioffice.ltd） -->
          <li class="download-item" v-if="brandSubdomain === 'miceai'">
            <div class="download-item__icon">
              <div class="icon-img">
                <img
                  class=""
                  src="../../assets/images/ai-img-android.png"
                  alt=""
                />
              </div>
            </div>
            <div class="download-item__actions">
              <h3 class="download-item__title">{{ $t("itwsAndroid.title") }}</h3>
              <div class="download-item__btns">
                <p class="bit-link">
                  <a
                    href="javascript:void(0);"
                    class="download-btn"
                    @click="
                      handleDownloadClick(
                        itwsAndroidDownload.url,
                        'itws_android',
                      )
                    "
                  >
                    <img
                      src="../../assets/images/a-img-download1.png"
                      width="20"
                      style="vertical-align: middle; margin-right: 5px"
                    />
                    {{ $t("itwsAndroid.linkOne") }}
                  </a>
                </p>
              </div>
            </div>
            <div class="download-item__version version-item">
              <p class="version-msg">
                {{ $t("android.updateTime") }}:
                {{ itwsAndroidDownload.updateTime | formatDate }}
              </p>
              <p class="version-msg">
                {{ $t("itwsAndroid.compatible") }}: Android
              </p>
            </div>
          </li>
          <!-- 云电脑版本 -->
          <li class="download-item" v-if="showCloudDesktopVersion">
            <div class="download-item__icon">
              <div class="icon-img">
                <img
                  class=""
                  src="../../assets/images/ai-img-yundesk.png"
                  alt=""
                />
              </div>
            </div>
            <div class="download-item__actions">
              <h3 class="download-item__title">{{ $t("windowYun.title") }}</h3>
              <div class="download-item__btns">
                <p class="bit-link">
                  <a
                    href="javascript:void(0);"
                    class="download-btn"
                    @click="
                      handleDownloadClick(
                        getDownloadYunUrl().url,
                        getDownloadYunUrl().version,
                      )
                    "
                  >
                    <img
                      src="../../assets/images/a-img-download1.png"
                      width="20"
                      style="vertical-align: middle; margin-right: 5px"
                    />
                    {{ $t("windowYun.linkOne") }}
                  </a>
                </p>
              </div>
            </div>
            <div class="download-item__version version-item">
              <p class="version-msg">
                {{ $t("windowYun.version") }}:
                {{ getDownloadYunUrl().version }}
              </p>
              <p class="version-msg">
                {{ $t("windowYun.updateTime") }}:
                {{ getDownloadYunUrl().createTime }}
              </p>
              <p class="version-msg">
                {{ $t("windowYun.compatible") }}: windows MobileYun
              </p>
            </div>
          </li>
          <!-- 统信版本 X86平台/ARM平台 -->
          <li class="download-item" v-if="showTongxinVersion">
            <div class="download-item__icon">
              <div class="icon-img">
                <img class="" src="../../assets/images/ai-img-tx.png" alt="" />
              </div>
            </div>
            <div class="download-item__actions">
              <h3 class="download-item__title">{{ $t("txYun.title") }}</h3>
              <div class="download-item__btns">
                <!-- 两个版本 -->
                <p class="bit-link" v-if="showTxDualPlatform">
                  <a
                    href="javascript:void(0);"
                    class="download-btn-small"
                    @click="
                      handleDownloadClick(
                        getDownloadTXUrl().url,
                        getDownloadTXUrl().version,
                      )
                    "
                  >
                    <img
                      src="../../assets/images/a-img-download1.png"
                      width="20"
                      style="vertical-align: middle; margin-right: 5px"
                    />
                    {{ $t("contact.x86link") }}
                  </a>
                  <a
                    href="javascript:void(0);"
                    class="download-btn-small"
                    @click="
                      handleDownloadClick(
                        getDownloadTXArmUrl().url,
                        getDownloadTXArmUrl().version,
                      )
                    "
                  >
                    <img
                      src="../../assets/images/a-img-download1.png"
                      width="20"
                      style="vertical-align: middle; margin-right: 5px"
                    />
                    {{ $t("contact.armlink") }}
                  </a>
                </p>
                <!-- 一个按钮 -->
                <p class="bit-link" v-else>
                  <a
                    href="javascript:void(0);"
                    class="download-btn"
                    @click="
                      handleDownloadClick(
                        getDownloadTXUrl().url,
                        getDownloadTXUrl().version,
                      )
                    "
                  >
                    <img
                      src="../../assets/images/a-img-download1.png"
                      width="20"
                      style="vertical-align: middle; margin-right: 5px"
                    />
                    {{ $t("txYun.linkOne") }}
                  </a>
                </p>
              </div>
            </div>
            <div class="download-item__version version-item">
              <p class="version-msg">
                {{ $t("txYun.version") }}:
                {{
                  useArmVersionInfo
                    ? getDownloadTXArmUrl().version
                    : getDownloadTXUrl().version
                }}
              </p>
              <p class="version-msg">
                {{ $t("txYun.updateTime") }}:
                {{
                  useArmVersionInfo
                    ? getDownloadTXArmUrl().createTime
                    : getDownloadTXUrl().createTime
                }}
              </p>
              <p class="version-msg" v-if="showTxCompatible">
                {{ $t("txYun.compatible") }}: UOS Desktop(X86)
              </p>
            </div>
          </li>

          <!-- 麒麟版本 X86平台/ARM平台 -->
          <li class="download-item" v-if="showQilinVersion">
            <div class="download-item__icon">
              <div class="icon-img">
                <img class="" src="../../assets/images/ai-img-ql.png" alt="" />
              </div>
            </div>
            <div class="download-item__actions">
              <h3 class="download-item__title">{{ $t("qlYun.title") }}</h3>
              <div class="download-item__btns">
                <!-- 两个版本 -->
                <p class="bit-link" v-if="showQlDualPlatform">
                  <a
                    href="javascript:void(0);"
                    class="download-btn-small"
                    @click="
                      handleDownloadClick(
                        getDownloadQLUrl().url,
                        getDownloadQLUrl().version,
                      )
                    "
                  >
                    <img
                      src="../../assets/images/a-img-download1.png"
                      width="20"
                      style="vertical-align: middle; margin-right: 5px"
                    />
                    {{ $t("contact.x86link") }}
                  </a>
                  <a
                    href="javascript:void(0);"
                    class="download-btn-small"
                    @click="
                      handleDownloadClick(
                        getDownloadQLArmUrl().url,
                        getDownloadQLArmUrl().version,
                      )
                    "
                  >
                    <img
                      src="../../assets/images/a-img-download1.png"
                      width="20"
                      style="vertical-align: middle; margin-right: 5px"
                    />
                    {{ $t("contact.armlink") }}
                  </a>
                </p>
                <!-- 一个按钮 -->
                <p class="bit-link" v-else>
                  <a
                    href="javascript:void(0);"
                    class="download-btn"
                    @click="
                      handleDownloadClick(
                        getDownloadQLUrl().url,
                        getDownloadQLUrl().version,
                      )
                    "
                  >
                    <img
                      src="../../assets/images/a-img-download1.png"
                      width="20"
                      style="vertical-align: middle; margin-right: 5px"
                    />
                    {{ $t("qlYun.linkOne") }}
                  </a>
                </p>
              </div>
            </div>
            <div class="download-item__version version-item">
              <p class="version-msg">
                {{ $t("qlYun.version") }}:
                {{
                  useArmVersionInfo
                    ? getDownloadQLArmUrl().version
                    : getDownloadQLUrl().version
                }}
              </p>
              <p class="version-msg">
                {{ $t("qlYun.updateTime") }}:
                {{
                  useArmVersionInfo
                    ? getDownloadQLArmUrl().createTime
                    : getDownloadQLUrl().createTime
                }}
              </p>
              <p class="version-msg" v-if="showQlCompatible">
                {{ $t("qlYun.compatible") }}: V10 and above
              </p>
            </div>
          </li>

          <!-- 单独 统信ARM版本 -->
          <!-- <li class="download-item" v-if="[''].includes(brandSubdomain)">
            <div class="icon-img">
              <img class="" src="../../assets/images/ai-img-tx.png" alt="" />
            </div>
            <div class="download-text">
              <h3>{{ $t("txYun.armTitle") }}</h3>
              <p class="bit-link">
                <a href="javascript:void(0);" class="download-btn"
                  @click="handleDownloadClick(getDownloadTXArmUrl().url, getDownloadTXArmUrl().version)">
                  <img src="../../assets/images/a-img-download1.png" width="20"
                    style="vertical-align: middle; margin-right: 5px" />
                  {{ $t("txYun.linkOne") }}
                </a>
              </p>
            </div>
            <div class="version-item">
              <p class="version-msg">
                {{ $t("txYun.version") }}: {{ getDownloadTXArmUrl().version }}
              </p>
              <p class="version-msg">
                {{ $t("txYun.updateTime") }}:
                {{ getDownloadTXArmUrl().createTime }}
              </p>
              <p class="version-msg">{{ $t("txYun.compatible") }}:{{ $t("qlYun.armTitle")}}</p>
            </div>
          </li> -->

          <!-- 单独 麒麟arm版本 -->
          <!-- <li class="download-item" v-if="['yff'].includes(brandSubdomain)">
            <div class="icon-img">
              <img class="" src="../../assets/images/ai-img-ql.png" alt="" />
            </div>
            <div class="download-text">
              <h3>{{ $t("qlYun.armTitle") }}</h3>
              <p class="bit-link">
                <a
                  href="javascript:void(0);"
                  class="download-btn"
                  @click="handleDownloadClick(getDownloadQLArmUrl().url, getDownloadQLArmUrl().version)"
                >
                  <img
                    src="../../assets/images/a-img-download1.png"
                    width="20"
                    style="vertical-align: middle; margin-right: 5px"
                  />
                  {{ $t("qlYun.linkOne") }}
                </a>
              </p>
            </div>
            <div class="version-item">
              <p class="version-msg">
                {{ $t("qlYun.version") }}: {{ getDownloadQLArmUrl().version }}
              </p>
              <p class="version-msg">
                {{ $t("qlYun.updateTime") }}:
                {{ getDownloadQLArmUrl().createTime }}
              </p>
              <p class="version-msg">
                {{ $t("qlYun.compatible") }}: {{ $t("qlYun.armTitle") }}
              </p>
            </div>
          </li> -->
        </ul>
      </div>
      <div class="history-version" v-if="hasGreenPackages">
        <div>
          <a href="javascript:;" @click="showGreenPackages = !showGreenPackages">{{
            $t("green.title")
          }}</a>
        </div>
        <div class="version-table" v-show="showGreenPackages">
          <div class="version-list">
            <table class="version-data">
              <tr>
                <th class="data-title">{{ $t("history.package") }}</th>
                <th class="data-title">{{ $t("history.product") }}</th>
                <th class="data-title">{{ $t("history.historyVersion") }}</th>
                <th class="data-title">{{ $t("history.applicableSystem") }}</th>
                <th class="data-title">{{ $t("history.time") }}</th>
                <th class="data-title">{{ $t("history.download") }}</th>
              </tr>
              <tr v-for="row in greenPackageRows" :key="row.id || 'green-' + row.version">
                <td class="data-content">
                  {{ row.title }}
                  <div class="version-intro" v-if="row.contents">
                    <img
                      class="info-img"
                      src="../../assets/images/info-circle-filled.png"
                      @mouseenter="showVersionDescribe('green-' + (row.id || row.version))"
                      @mouseleave="hideVersionDescribe"
                    />
                    <div
                      class="detailed box-shadow"
                      v-if="describeId == 'green-' + (row.id || row.version)"
                    >
                      <h5 class="desc-title">
                        <img
                          src="../../assets/images/info-circle-filled-b.png"
                        />版本说明
                      </h5>
                      <p v-html="row.contents"></p>
                    </div>
                  </div>
                </td>
                <td class="data-content">{{ row.product }}</td>
                <td class="data-content">{{ row.version }}</td>
                <td class="data-content">
                  <img
                    class="data-icon"
                    src="../../assets/images/ai-img-w.png"
                    alt=""
                  />
                </td>
                <td class="data-content">
                  {{ row.createTime | formatDate }}
                </td>
                <td class="data-content">
                  <img
                    class="data-download"
                    src="../../assets/images/ai-img-download.png"
                    width="20"
                    height="20"
                  />
                  <a
                    href="javascript:void(0);"
                    class="current-download"
                    @click="handleDownloadClick(row.url, row.version)"
                    >{{ $t("history.download") }}</a
                  >
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="history-version" v-if="['www'].includes(brandSubdomain)">
        <!-- <router-link to="/HistoryVersion" target="_blank">展开所有历史版本</router-link> -->
        <div>
          <a href="javascript:;" @click="showAllVersions = !showAllVersions">{{
            $t("history.title")
          }}</a>
        </div>
        <!-- 各版本列表 -->
        <div class="version-table" v-show="showAllVersions">
          <!-- <div class="version-no">
						<p>{{$t('history.tip')}}</p>
					</div> -->
          <div class="version-list">
            <table class="version-data">
              <tr>
                <th class="data-title">{{ $t("history.package") }}</th>
                <th class="data-title">{{ $t("history.product") }}</th>
                <th class="data-title">{{ $t("history.historyVersion") }}</th>
                <th class="data-title">{{ $t("history.applicableSystem") }}</th>
                <th class="data-title">{{ $t("history.time") }}</th>
                <th class="data-title">{{ $t("history.download") }}</th>
              </tr>
              <tr v-for="window in windowVersions" :key="window.id">
                <td class="data-content">
                  <!-- <img class="data-icon" src="../../assets/images/ai-img-w.png" alt="" /> -->
                  {{ window.title }}
                  <div class="version-intro">
                    <img
                      class="info-img"
                      src="../../assets/images/info-circle-filled.png"
                      @mouseenter="showVersionDescribe(window.id)"
                      @mouseleave="hideVersionDescribe"
                    />
                    <div
                      class="detailed box-shadow"
                      v-if="describeId == window.id"
                    >
                      <h5 class="desc-title">
                        <img
                          src="../../assets/images/info-circle-filled-b.png"
                        />版本说明
                      </h5>
                      <p v-html="window.contents"></p>
                    </div>
                  </div>
                </td>
                <td class="data-content">{{ window.product }}</td>
                <td class="data-content">{{ window.version }}</td>
                <td class="data-content">
                  <img
                    class="data-icon"
                    src="../../assets/images/ai-img-w.png"
                    alt=""
                  />
                </td>
                <td class="data-content">
                  {{ window.createTime | formatDate }}
                </td>
                <td class="data-content">
                  <img
                    class="data-download"
                    src="../../assets/images/ai-img-download.png"
                    width="20"
                    height="20"
                  />
                  <a
                    href="javascript:void(0);"
                    class="current-download"
                    @click="handleDownloadClick(window.url, window.version)"
                    >{{ $t("history.download") }}</a
                  >
                </td>
              </tr>
              <tr v-for="mac in macVersions" :key="mac.id">
                <td class="data-content">
                  {{ mac.title }}
                  <div class="version-intro">
                    <img
                      class="info-img"
                      src="../../assets/images/info-circle-filled.png"
                      @mouseenter="showVersionDescribe(mac.id)"
                      @mouseleave="hideVersionDescribe"
                    />
                    <div
                      class="detailed box-shadow"
                      v-if="describeId == mac.id"
                    >
                      <h5 class="desc-title">
                        <img
                          src="../../assets/images/info-circle-filled-b.png"
                        />版本说明
                      </h5>
                      <p>
                        {{ mac.contents }}
                      </p>
                    </div>
                  </div>
                </td>
                <td class="data-content">{{ mac.version }}</td>
                <td class="data-content">
                  <img
                    class="data-icon"
                    src="../../assets/images/ai-img-apple.png"
                    alt=""
                  />
                </td>
                <td class="data-content">{{ mac.createTime | formatDate }}</td>
                <td class="data-content">
                  <img
                    class="data-download"
                    src="../../assets/images/ai-img-download.png"
                    width="20"
                    height="20"
                  />
                  <a
                    href="javascript:void(0);"
                    class="current-download"
                    @click="handleDownloadClick(mac.url, mac.version)"
                    >{{ $t("history.download") }}</a
                  >
                </td>
              </tr>
              <tr v-for="android in androidVersions" :key="android.id">
                <td class="data-content">
                  <!-- <img class="data-icon" src="../../assets/images/ai-img-android.png" alt="" /> -->
                  {{ android.title }}
                  <div class="version-intro">
                    <img
                      class="info-img"
                      src="../../assets/images/info-circle-filled.png"
                      @mouseenter="showVersionDescribe(android.id)"
                      @mouseleave="hideVersionDescribe"
                    />
                    <div
                      class="detailed box-shadow"
                      v-if="describeId == android.id"
                    >
                      <h5 class="desc-title">
                        <img
                          src="../../assets/images/info-circle-filled-b.png"
                        />版本说明
                      </h5>
                      <p>
                        {{ android.contents }}
                      </p>
                    </div>
                  </div>
                </td>
                <td class="data-content">{{ android.version }}</td>
                <td class="data-content">
                  <img
                    class="data-icon"
                    src="../../assets/images/ai-img-android.png"
                    alt=""
                  />
                </td>
                <td class="data-content">
                  {{ android.createTime | formatDate }}
                </td>
                <td class="data-content p-relative">
                  <img
                    class="data-download"
                    src="../../assets/images/ai-img-download.png"
                    width="20"
                    height="20"
                  />
                  <a
                    href="javascript:void(0);"
                    class="current-download"
                    @click="handleDownloadClick(android.url, android.version)"
                    >{{ $t("history.download") }}</a
                  >
                  <img
                    class="data-download"
                    src="../../assets/images/ai-img-scan.png"
                    width="20"
                    height="20"
                    @mouseenter="qrShow = true"
                    @mouseleave="qrShow = false"
                  />
                  <vue-qr
                    :logoSrc="logoIcon"
                    class="qr-img box-shadow"
                    v-if="qrShow"
                    :text="android.url"
                  ></vue-qr>
                </td>
              </tr>
              <tr v-for="patch in qdVersions" :key="patch.id">
                <td class="data-content">{{ patch.title }}</td>
                <td class="data-content">{{ patch.version }}</td>
                <td class="data-content">
                  <img
                    class="data-icon"
                    src="../../assets/images/ai-img-qd.png"
                    alt=""
                  />
                </td>
                <td class="data-content">
                  {{ patch.createTime | formatDate }}
                </td>
                <td class="data-content">
                  <img
                    class="data-download"
                    src="../../assets/images/ai-img-download.png"
                    width="20"
                    height="20"
                  />
                  <a
                    href="javascript:void(0);"
                    class="current-download"
                    @click="handleDownloadClick(patch.url, patch.version)"
                    >{{ $t("history.download") }}</a
                  >
                </td>
              </tr>
              <tr v-for="hty in historyVersions" :key="hty.id">
                <td class="data-content">
                  <img
                    class="data-icon"
                    v-if="hty.version && hty.version.indexOf('Mouse') != -1"
                    src="../../assets/images/ai-img-mouse1.png"
                    alt=""
                  />
                  <img
                    class="data-icon"
                    v-if="hty.version && hty.version.indexOf('Pointer') != -1"
                    src="../../assets/images/ai-img-pen.png"
                    alt=""
                  />
                  <img
                    class="data-icon"
                    v-if="hty.version && hty.version.indexOf('Recorder') != -1"
                    src="../../assets/images/ai-img-recorder.png"
                    alt=""
                  />
                  <img
                    class="data-icon"
                    v-else-if="
                      hty.version &&
                      hty.version.indexOf('Mouse') == -1 &&
                      hty.version.indexOf('Pointer') == -1 &&
                      hty.version.indexOf('Recorder') == -1
                    "
                    src="../../assets/logo/qingjing/ai-img-logo2.png"
                    alt=""
                  />
                  {{ hty.title }}
                  <div class="version-intro">
                    <img
                      class="info-img"
                      src="../../assets/images/info-circle-filled.png"
                      @mouseenter="showVersionDescribe(hty.id)"
                      @mouseleave="hideVersionDescribe"
                    />
                    <div
                      class="detailed box-shadow"
                      v-if="describeId == hty.id"
                    >
                      <h5 class="desc-title">
                        <img
                          src="../../assets/images/info-circle-filled-b.png"
                        />版本说明
                      </h5>
                      <p v-html="hty.contents"></p>
                    </div>
                  </div>
                </td>
                <td class="data-content">
                  <p v-if="hty.products && hty.products[0] == 'Mouse'">鼠标</p>
                  <p v-if="hty.products && hty.products[0] == 'Pointer'">
                    翻页笔
                  </p>
                  <p v-if="hty.products && hty.products[0] == 'Recorder'">
                    录音笔
                  </p>
                </td>
                <td class="data-content">{{ hty.version }}</td>
                <td class="data-content">
                  <p v-if="hty.platform == 'Mac'">
                    <img
                      class="data-icon"
                      src="../../assets/images/ai-img-apple.png"
                      alt=""
                    />
                  </p>
                  <p v-if="hty.platform == 'Android'">
                    <img
                      class="data-icon"
                      src="../../assets/images/ai-img-android.png"
                      alt=""
                    />
                  </p>
                  <p v-if="hty.platform == 'Windows'">
                    <img
                      class="data-icon"
                      src="../../assets/images/ai-img-w.png"
                      alt=""
                    />
                  </p>
                </td>
                <td class="data-content">{{ hty.createTime | formatDate }}</td>
                <td class="data-content p-relative">
                  <img
                    class="data-download"
                    src="../../assets/images/ai-img-download.png"
                    width="20"
                    height="20"
                  />
                  <a
                    href="javascript:void(0);"
                    class="current-download"
                    @click="handleDownloadClick(hty.url, hty.version)"
                    >{{ $t("history.download") }}</a
                  >
                  <img
                    class="data-download"
                    v-if="hty.platform == 'Android'"
                    src="../../assets/images/ai-img-scan.png"
                    width="20"
                    height="20"
                    @mouseenter="qrShow = hty.id"
                    @mouseleave="qrShow = false"
                  />
                  <vue-qr
                    :logoSrc="logoIcon"
                    class="qr-img box-shadow"
                    v-if="qrShow == hty.id"
                    :text="hty.url"
                  ></vue-qr>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vueQr from "vue-qr";
import store from "@/store/index.js";
import { sendStatEvent } from "../../util/stat.js";
import { defauleTheme, setMainColor } from "../../util/index.js";

/**
 * Mac/桌面端 AppId 配置（按优先级：精确域名 > curHost > brandSubdomain）
 * 新增映射只需在此处添加一行，无需改 getAppId 逻辑
 */
const APP_ID_CONFIG = {
  // 精确域名 -> AppId（优先级最高）
  domain: {
    "jiyuai.gpt-mouse.com": "AiOffice-Electron-Destop",
    "iting.imouse.shop": "Cloudeer-Electron-Destop",
    "telecomstar.imouse.shop": "TelecomStar-Electron-Destop",
    "www.aioffice.ltd": "AiOffice-Electron-Destop",
    "app.gpt-mouse.com": "AiOffice-Electron-Destop",
    "www.imouse.shop": "AiOffice-Electron-Destop"
  },
  // 纯二级域名curHost -> AppId
  host: {
    erazer2: "Erazer-Electron-Destop",
    dioc:"Dioc-Electron-Destop",
    jiazhen:"JiaZhen-Electron-Destop",
    cmcc: "MouseMate-Electron-Destop",
    telecom:"TelecomStar-Electron-Destop",
    aishoujia: "AiOffice-Electron-AiShouJia",
    pctenk: "Pctenk-Electron-Destop",
    dike: "DiKe-Electron-Destop",
    yundesk: "AiOffice-Electron-Destop",
    m70: "AiOffice-Electron-Destop",
    meitai: "AiOffice-Electron-Destop",
    wifi: "AiOffice-Electron-Destop",
    cloudeer: "AiOffice-Electron-Destop",
    colorful: "Colorful-Electron-Destop",
    cmcloud: "AiOffice-H5-MiGu-Destop",
    greatwall: "AiOffice-XiaoDun-Destop",
    aioa: "AiOffice-H5-FX-Destop",
    jiabo: "AiOffice-H5-JiaBo-Destop",
    zhunxin: "AiOffice-H5-ZhunXin-Destop",
    // jiyuai: "AiOffice-H5-JIYUAI-Destop",
    shinco: "AiOffice-H5-Shinco-Destop",
    lefan: "AiOffice-H5-LeFan-Destop",
    'lf-zjzs': "AiOffice-H5-LeFan-Destop",
    sir: "AiOffice-H5-LefanLittleMan-Destop",
    sheenhan: "AiOffice-H5-Sheenhan",
    shihan: "AiOffice-H5-Sheenhan",
    miaowang: "AiOffice-H5-MiaoWang-Destop",
    mifi: "AiOffice-H5-MIFI-Destop",
    ysd: "AiOffice-H5-YiShanDe-Destop",
    akpnai: "AiOffice-H5-AkpnAI-Destop",
    hyundai: "AiOffice-H5-HYunDai-Destop",
    yff: "AiOffice-H5-YunFeiFan-Destop",
    aiodiy: "AioDiy-Electron-Destop",
    jiajing: "AiOffice-H5-JiaJing-Destop",
    xunxiang: "AiOffice-H5-XunXiang-Destop",
    ynz: "AiOffice-H5-ERAZER-Destop",
    myai: "AiOffice-H5-MeiYan-Destop",
    // V6 使用 H5 的 host（与下方 default 一致，可省略则走 default）
    www: "AiOffice-Destop-H5",
    app: "AiOffice-Destop-H5",
    imouse: "AiOffice-Destop-H5",
    eweadn: "AiOffice-Destop-H5",
    dario: "AiOffice-Destop-H5",
    xbantu: "AiOffice-Destop-H5",
    metav: "AiOffice-Destop-H5",
    wo: "AiOffice-Destop-H5",
    tele: "AiOffice-Destop-H5",
    smartdone: "AiOffice-Destop-H5",
    taiguo: "AiOffice-Destop-H5",
    p70: "AiOffice-Destop-H5",
  },
  // brandSubdomain（.aioffice.ltd格式前的字符串）：先精确匹配，再按顺序 includes 匹配（先匹配到的生效）
  brandExact: {
    "zkyn.gpt-mouse.com": "AiOffice-H5-ZhongKeYuNeng-Destop",
    "jz-kreata":"JiaZhen-Kreata-Electron-Destop"
  },
  // brandSubdomain（.aioffice.ltd格式前的字符串）：includes 匹配（按配置顺序取第一个）
  brandIncludes: [
    { pattern: "lingxi", appId: "Lingxi-Destop" },
    { pattern: "hbs", appId: "AiOffice-H5-Broadcasting-Destop" },
    { pattern: "zxhy", appId: "AiOffice-H5-ZhongXinHongYe-Destop" },
    { pattern: "erazer", appId: "AiOffice-H5-ERAZER-Destop" },
    { pattern: "acer", appId: "AiOffice-H5-AcerAI-Destop" },
    { pattern: "xazyzz-fuhua", appId: "AiOffice-H5-RongChuang" },
    { pattern: "dakai", appId: "AiOffice-H5-DaKai" },
    { pattern: "mini", appId: "AiOffice-H5-iTingMini-Destop" },
    { pattern: "qualmeta", appId: "AiOffice-H5-FullComm-Destop" },
    { pattern: "baseus", appId: "AiOffice-Baseus-Destop" },
    { pattern: "keliumao", appId: "AiOffice-H5-Keliumao-Destop" },
    { pattern: "xwt", appId: "AiOffice-H5-XingWeiTe-Destop" },
    { pattern: "yh", appId: "AiOffice-H5-YingHai-Destop" },
    { pattern: "jingying", appId: "AiOffice-H5-JingYingAI-Destop" },
    { pattern: "huachuang", appId: "AiOffice-H5-LeFanHuaChuang-Destop" },
    { pattern: "newland", appId: "AiOffice-H5-Newland-Destop" },
    { pattern: "aiezyzwl", appId: "AiOffice-H5-AIEZ-Destop" },
  ],
  // *.aioffice.ltd 下无匹配时的默认值
  defaultForAiofficeLtd: "AiOffice-Electron-Destop",
  // 其他域名无匹配时的默认值
  default: "AiOffice-Destop-H5",
};

/** miceai.aioffice.ltd 固定 APK（非版本接口）；发布新包时请同步修改 updateTime */
const ITWS_ANDROID_DOWNLOAD = {
  url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/android/earphone/app/itws_release_1.apk",
  updateTime: new Date("2026-05-08").getTime(),
};

export default {
  data() {
    return {
      itwsAndroidDownload: ITWS_ANDROID_DOWNLOAD,
      curHost: "",
      bitFlag: 0,
      versionFlag: 0,
      showAllVersions: false,
      showGreenPackages: true,
      qrShow: false,
      logoIcon: require("../../assets/logo/qingjing/ai-img-logo2.png"),
      describeId: "",
      //鼠标滑过控制
      androidIcon: true,
      androidCode: false,
      //最新的版本
      newWindow: {},
      newWindowMobile: {},
      newWindowBeta: {},
      newGreen: {},
      newMac: {},
      newAndroid: {},
      newPatch: {},
      //所有版本数组
      windowVersions: [],
      macVersions: [],
      androidVersions: [],
      qdVersions: [],
      historyVersions: [],
      windowBetaVersions: [], //内测版本
      ipAddress: "https://apiv2.iting.chat/api", //  生产：https://apiv2.iting.chat/api， 开发：https://devapi.qjzn.ltd/api
      domainName: "",
      brandSubdomain: "",
      // 域名配置常量 - 统一管理，便于维护
      domainConfig: {
        // 支持统信和麒麟版本的域名列表
        linuxSupported: [
          "yundesk",
          "wo",
          "pansheng",
          "newland",
          "m70",
          "p70",
          "i70",
          "m7",
          "zuoh",
          "sheenhan",
          "shihan",
          "yff",
          "tele",
          "hbs",
          "www.hbs",
          "beite",
          "wifi",
        ],
        // 支持云电脑版本的域名列表（在linuxSupported基础上增加）
        cloudDesktopSupported: [
          "yundesk",
          "wo",
          "pansheng",
          "newland",
          "m70",
          "p70",
          "i70",
          "m7",
          "zuoh",
          "sheenhan",
          "shihan",
          "yff",
          "tele",
          "hbs",
          "www.hbs",
          "beite",
     
          "zxhyyun",
        ],
        // 统信版本支持双平台（X86/ARM）的域名列表
        txDualPlatform: ["beite", "wifi", "yundesk"],
        // 麒麟版本支持双平台（X86/ARM）的域名列表
        qlDualPlatform: ["beite", "hbs", "yff", "wifi", "yundesk"],
        // 使用ARM版本的域名（默认显示ARM版本信息）
        useArmVersion: ["yundesk"],
        // 特殊域名列表（需要特殊处理的完整域名）
        specialDomains: [
          "kaitian.imouse.shop",
          // 可以在这里添加更多特殊域名
          // 'example1.com',
          // 'example2.com',
        ],
      },
    };
  },
  computed: {
    // 是否显示统信版本
    showTongxinVersion() {
      return (
        this.domainConfig.linuxSupported.includes(this.curHost) ||
        this.isSpecialDomain()
      );
    },
    // 是否显示麒麟版本
    showQilinVersion() {
      return (
        this.domainConfig.linuxSupported.includes(this.curHost) ||
        this.isSpecialDomain()
      );
    },
    // 是否显示云电脑版本
    showCloudDesktopVersion() {
      return (
        this.domainConfig.cloudDesktopSupported.includes(this.curHost) ||
        this.isSpecialDomain()
      );
    },
    // 统信版本是否显示双平台按钮
    showTxDualPlatform() {
      return (
        this.domainConfig.txDualPlatform.includes(this.brandSubdomain) ||
        this.isSpecialDomain()
      );
    },
    // 麒麟版本是否显示双平台按钮
    showQlDualPlatform() {
      return (
        this.domainConfig.qlDualPlatform.includes(this.brandSubdomain) ||
        this.isSpecialDomain()
      );
    },
    // 是否使用ARM版本信息（用于版本号和时间显示）
    useArmVersionInfo() {
      return this.domainConfig.useArmVersion.includes(this.curHost);
    },
    // 统信版本兼容性信息是否显示
    showTxCompatible() {
      return !this.domainConfig.txDualPlatform.includes(this.brandSubdomain);
    },
    // 麒麟版本兼容性信息是否显示
    showQlCompatible() {
      return !this.domainConfig.qlDualPlatform.includes(this.brandSubdomain);
    },
    /** 绿色安装包表格行（接口返回单条 GreenApp） */
    greenPackageRows() {
      const g = this.newGreen;
      if (!g || typeof g !== "object") return [];
      const hasData =
        (g.url && String(g.url).length > 0) ||
        (g.version && String(g.version).length > 0);
      return hasData ? [g] : [];
    },
    hasGreenPackages() {
      return this.greenPackageRows.length > 0;
    },
    /** 当前可见的下载卡片数量（与模板 v-if 条件保持一致） */
    downloadItemCount() {
      let count = 0;
      if (this.newWindow && this.newWindow.url) {
        count += 1; // Windows
      }
      if (this.newMac && this.newMac.url) {
        count += 1; // Mac
      }
      if (
        ["cloudeer", "lf-zjzs"].includes(this.brandSubdomain) &&
        this.newAndroid &&
        this.newAndroid.url
      ) {
        count += 1;
      }
      if (this.brandSubdomain === "miceai") {
        count += 1;
      }
      if (this.showCloudDesktopVersion) {
        count += 1;
      }
      if (this.showTongxinVersion) {
        count += 1;
      }
      if (this.showQilinVersion) {
        count += 1;
      }
      return count;
    },
  },
  components: {
    vueQr,
  },
  mounted() {
    this.curHost = store.getters["getCurrentHost"];
    this.domainName = store.getters["getCurrentDomainName"];
    this.brandSubdomain = store.getters["getBrandSubdomain"];
    this.setPageColor();
    //获取接口中心数据
    this.fetchVersions();
  },
  filters: {
    //配置过滤器
    formatDate: function (value) {
      //调用时间戳为日期显示
      let date = new Date(value);
      let y = date.getFullYear(); //获取年份
      let m = date.getMonth() + 1; //获取月份
      m = m < 10 ? "0" + m : m; //月份不满10天显示前加0
      let d = date.getDate(); //获取日期
      d = d < 10 ? "0" + d : d; //日期不满10天显示前加0
      return y + "-" + m + "-" + d;
      //也可以获取更精准时间
      //let h = date.getHours(),                   //小时
      //let m = date.getMinutes(),                 //分
      //let s = date.getSeconds(),                 //秒
      //let ls = date.getMilliseconds()            //毫秒
    },
  },
  methods: {
    // 判断是否为特殊域名
    isSpecialDomain() {
      return this.domainConfig.specialDomains.includes(this.domainName);
    },
    // 仅在 resp_code 为 "0"（查找到可用版本）时返回 datas，否则返回空对象
    extractDatas(response) {
      const data = response && response.data;
      if (data && String(data.resp_code) === "0" && data.datas) {
        return data.datas;
      }
      return {};
    },
    // 是否为 Mac 或 Safari（弹窗拦截严格，改用当前页下载）
    isStrictPopupEnv() {
      const ua = navigator.userAgent || "";
      return /Macintosh|Mac OS/i.test(ua) || /Safari\//i.test(ua);
    },
    // 处理下载链接点击事件
    async handleDownloadClick(originalUrl, version) {
      // 防抖：同一链接短时间内不可重复点击
      if (!this._downloadDebounceMap) {
        this._downloadDebounceMap = {};
      }
      if (originalUrl && this._downloadDebounceMap[originalUrl]) {
        return;
      }
      this._downloadDebounceMap[originalUrl] = true;
      setTimeout(() => {
        delete this._downloadDebounceMap[originalUrl];
      }, 3000);

      if(originalUrl == '') {
        alert('No installation package');
        return;
      }
      let finalUrl = originalUrl;

      // 检查是否包含download3域名
      if (originalUrl && originalUrl.includes("download3.iting.chat")) {
        try {
          const response = await axios.post(
            `${this.ipAddress}/api-file/generic/getCdnAuthKey`,
            {
              url: originalUrl,
            },
            {
              headers: {
                "Content-Type": "application/json;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
              },
            },
          );

          if (
            response.data &&
            response.data.resp_code === "0" &&
            response.data.resp_msg
          ) {
            // 在原始URL后添加认证密钥参数
            const separator = originalUrl.includes("?") ? "&" : "?";
            finalUrl = `${originalUrl}${separator}auth_key=${response.data.resp_msg}`;
            console.log(finalUrl, "最终下载地址");
          }
        } catch (error) {
          console.error("获取CDN认证密钥失败:", error);
        }
      }

      // 发送统计事件
      if (version) {
        this.postStatEvent(version);
      }

      // 触发下载（使用隐藏iframe，避免window.open/新标签导致的页面闪烁）
      if (finalUrl) {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = finalUrl;
        document.body.appendChild(iframe);
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 60000);
      }
    },

    // 设置页面主色调
    setPageColor() {
      let theme = defauleTheme;
      if (this.brandSubdomain.includes("xunxiang")) {
        theme = "#00a0ea";
      } else if (this.brandSubdomain.includes("hbs")) {
        theme = "#34a8e1";
      } else if (this.brandSubdomain.includes("zxhy")) {
        theme = "#03D3C6";
      } else if (this.brandSubdomain.includes("keliumao")) {
        theme = "#F86B24 ";
      } else if (this.brandSubdomain.includes("cmcloud")) {
        theme = "#1F47A1 ";
      }
      console.log(theme, "theme");

      setMainColor(theme);
    },
    // 根据不同域名取不同的APPID
    getAndroidAppId() {
      if (this.curHost === "lf-zjzs") {
        return "AiOffice-App-ZJZH";
      }

      return "AiOffice-App";
    },
    // app.gpt-mouse.com 的 Windows（移动版）AppId
    getWindowsMobileAppId() {
      console.log(this.domainName, ["app.gpt-mouse.com", "www.imouse.shop"].includes(this.domainName),'this.domainNamethis.domainNamethis.domainNamethis.domainNamethis.domainName');
      
      if (
        ["app.gpt-mouse.com", "www.imouse.shop"].includes(this.domainName)
      ) {

        return "MouseMate-Electron-Destop";
      }
      return "";
    },

    /**
     * 根据不同域名取不同的 AppId（用于 Mac 等其他平台）
     * 映射规则见文件顶部 APP_ID_CONFIG，新增/修改只需改配置
     */
    getAppId() {
      const { domainName, curHost, brandSubdomain } = this;
      const { domain, host, brandExact, brandIncludes, defaultForAiofficeLtd, default: defaultAppId } = APP_ID_CONFIG;

      // 1. 精确域名
      if (domainName && domain[domainName]) {
        return domain[domainName];
      }
      // 2. curHost
      if (curHost && host[curHost]) {
        return host[curHost];
      }
      // 3. brandSubdomain 精确匹配
      if (brandSubdomain && brandExact[brandSubdomain]) {
        return brandExact[brandSubdomain];
      }
      // 4. brandSubdomain includes 匹配（按配置顺序取第一个）
      if (brandSubdomain) {
        const found = brandIncludes.find((item) => brandSubdomain.includes(item.pattern));
        if (found) return found.appId;
      }
      // 5. *.aioffice.ltd 默认
      if (domainName && domainName.endsWith("aioffice.ltd")) {
        return defaultForAiofficeLtd;
      }
      // 6. 其他（如 .imouse.shop 等）默认 Electron
      if (domainName && domainName.includes(".imouse.shop")) {
        return defaultForAiofficeLtd;
      }
      return defaultAppId;
    },

    // 接口数据
    async fetchVersions() {
      const AppId = this.getAppId();
      const AndroidAppId = this.getAndroidAppId();
      const WindowsMobileAppId = this.getWindowsMobileAppId();

      const requests = [
        `${this.ipAddress}/api-product/versionManagement/downloadByAppId?appId=${AppId}&platform=Windows&packageType=DesktopFull`,
        `${this.ipAddress}/api-product/versionManagement/downloadByAppId?appId=${AppId}&platform=Windows&packageType=GreenApp`,
        `${this.ipAddress}/api-product/versionManagement/downloadByAppId?appId=${AppId}&platform=MacOs&packageType=DesktopFull`,
        `${this.ipAddress}/api-product/versionManagement/downloadByAppId?appId=${AndroidAppId}&platform=Android&packageType=App`,
        `${this.ipAddress}/api-product/versionManagement/page?appId=AiOffice-History&platform=&packageType=&pageSize=100&pageNumber=1`,
      ];
      if (WindowsMobileAppId) {
        requests.push(
          `${this.ipAddress}/api-product/versionManagement/downloadByAppId?appId=${WindowsMobileAppId}&platform=Windows&packageType=DesktopFull`,
        );
      }

      try {
        for (const request of requests) {
          const response = await axios.get(request, {
            headers: {
              "Content-Type": "application/json;charset=utf-8",
              "Access-Control-Allow-Origin": "*",
            },
          });

          // 根据请求的顺序将响应数据赋值给相应的变量
          if (
            request.includes("DesktopFull") &&
            request.includes("Windows") &&
            !request.includes("GreenApp") &&
            (!WindowsMobileAppId ||
              !request.includes(`appId=${WindowsMobileAppId}`))
          ) {
            this.newWindow = this.extractDatas(response);
          } else if (request.includes("GreenApp")) {
            this.newGreen = this.extractDatas(response);
          } else if (request.includes("MacOs")) {
            this.newMac = this.extractDatas(response);
          } else if (request.includes("Android")) {
            this.newAndroid = this.extractDatas(response);
          } else if (request.includes("AiOffice-History")) {
            this.historyVersions = response.data.datas?.list || [];
            // if (this.newGreen) {
            //   this.historyVersions = [this.newGreen, ...historyData];
            // } else {
            //   this.historyVersions = historyData;
            // }
          } else if (
            WindowsMobileAppId &&
            request.includes(`appId=${WindowsMobileAppId}`) &&
            request.includes("Windows") &&
            request.includes("DesktopFull")
          ) {
            this.newWindowMobile = this.extractDatas(response);
          }
        }

        // 针对meitai主机的特殊处理
        if (this.curHost === "meitai") {
          this.newWindow = {
            ...this.newWindow,
            version: "7.0.41",
            url: "https://download1.iting.chat/windows/aioffice/app/AiOffice_7.0.41.exe",
          };
        }
      } catch (error) {
        console.error("Error fetching versions:", error);
      }
    },

    //鼠标滑过显示二维码
    overAndroidCode() {
      this.androidIcon = false;
      this.androidCode = true;
    },
    outAndroidCode() {
      this.androidIcon = true;
      this.androidCode = false;
    },
    checkHistoryVersion(index) {
      this.versionFlag = index;
    },
    //版本说明介绍
    showVersionDescribe(id) {
      this.describeId = id;
    },
    hideVersionDescribe() {
      this.describeId = "";
    },
    showQrCode() {},

    //发送统计消息到后台
    postStatEvent(version) {
      const val = {
        iting_event_name: "iting_event_download", // 下载
        iting_stat_domain: this.domainName,
        iting_stat_platform: this.userAgent(), //平台  Windows | Mac
        iting_stat_version: version, //版本
        iting_stat_brand: this.curHost, //品牌客户名称
      };
      sendStatEvent("iting_event_download", JSON.stringify(val));
    },

    // 检查操作系统
    userAgent() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (
        userAgent.includes("mac") ||
        userAgent.includes("ipad") ||
        userAgent.includes("iphone") ||
        userAgent.includes("ipod")
      ) {
        return "Mac";
      }
      if (userAgent.includes("windows")) {
        return "Windows";
      }
      return "";
    },

    // 云电脑
    getDownloadYunUrl() {
      if (this.curHost == "m70") {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/yun/YunOffice_6.1.1.2_m70.exe",
          version: "1.8.2.3",
          createTime: "2024-8-21",
        };
      } else if (this.curHost == "zuoh") {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/yun/YunOffice_6.1.1.2_D2.exe",
          version: "1.8.2.3",
          createTime: "2024-8-21",
        };
      } else if (this.curHost == "sheenhan" || this.curHost == "shihan") {
        return {
          url: "https://download.iting.chat/aioffice/custom/ShiHan/yun/SheenhanYun_6.2.0.1.exe",
          version: "6.2.0.1",
          createTime: "2025-3-5",
        };
      } else if (this.curHost == "yff") {
        return {
          url: "https://download1.iting.chat/custom/yunfeifan/yun/YunOffice_6.2.0.17.exe",
          version: "6.2.0.17",
          createTime: "2025-3-19",
        };
      } else if (this.curHost == "tele") {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/yun/YunOffice_6.2.0.2.exe",
          version: "6.2.0.2",
          createTime: "2024-9-12",
        };
      } else if (this.curHost == "newland") {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/yun/YunOffice_6.2.0.23.exe",
          version: "6.2.0.23",
          createTime: "2025-11-20",
        };
      } else if (this.brandSubdomain.includes("hbs")) {
        return {
          url: "https://download.iting.chat/aioffice/aioffice/yun/YunOffice_6.2.0.7.exe",
          version: "6.2.0.7",
          createTime: "2025-3-20",
        };
      } else if (this.curHost == "pansheng") {
        return {
          url: "https://download.iting.chat/aioffice/custom/xindaluPansheng/YunOffice_6.2.0.3.exe",
          version: "6.2.0.3",
          createTime: "2024-10-30",
        };
      } else if (this.curHost == "beite") {
        return {
          url: "https://download.iting.chat/aioffice/custom/beite/YunOffice_6.2.0.4.exe",
          version: "6.2.0.4",
          createTime: "2024-11-25",
        };
      } else if (this.curHost == "yundesk") {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/yun/YunOffice_6.2.0.4.exe",
          version: "6.2.0.4",
          createTime: "2026-3-10",
        };
      } else if ( this.isSpecialDomain()) {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/yun/AiOffice_7.2.20.exe",
          version: "7.2.20",
          createTime: "2025-12-25",
        };
      } else if (this.curHost == "zxhyyun") {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/custom/zhongxinhongye/YunOffice_1.0.2.exe",
          version: "1.0.2",
          createTime: "2025-3-25",
        };
      } else {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/yun/YunOffice_6.1.1.0.exe",
          version: "6.1.1.0",
          createTime: "2024-6-28",
        };
      }
    },

    //统信X86
    getDownloadTXUrl() {
      if (this.curHost == "m70" || this.curHost == "zuoh") {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/Linux/tongxin/ai.iting.aioffice-uos_1.8.2.3_amd64.deb",
          version: "1.8.2.3",
          createTime: "2024-8-21",
        };
      } else if (this.curHost == "sheenhan" || this.curHost == "shihan") {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/custom/sheenhan/ai.iting.sheenhan-uos_1.8.2.1_amd64.deb",
          version: "1.8.2.1",
          createTime: "2024-8-16",
        };
      } else if (this.curHost == "yff") {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/custom/yunfeifan/ai.iting.yunfeifan-uos_1.8.2.3_amd64.deb",
          version: "1.8.2.3",
          createTime: "2024-8-27",
        };
      } else if (this.curHost == "tele") {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/Linux/tongxin/ai.iting.aioffice-uos_1.8.2.5_amd64.deb",
          version: "1.8.2.5",
          createTime: "2024-9-12",
        };
      } else if (this.curHost == "newland") {
        return {
          url: "https://download.iting.chat/aioffice/aioffice/ai.iting.aioffice-uos_1.8.2.6_amd64.deb",
          version: "1.8.2.6",
          createTime: "2024-10-12",
        };
      } else if (this.brandSubdomain.includes("hbs")) {
        return {
          url: "https://download.iting.chat/aioffice/aioffice/tongxin-x86/ai.iting.aioffice-uos_1.8.2.9_amd64.deb",
          version: "1.8.2.9",
          createTime: "2025-3-20",
        };
      } else if (this.curHost == "pansheng") {
        return {
          url: "https://download.iting.chat/aioffice/custom/xindaluPansheng/ai.iting.aioffice-uos_1.8.2.7_amd64.deb",
          version: "1.8.2.7",
          createTime: "2024-10-30",
        };
      } else if (this.curHost == "beite") {
        return {
          url: "https://download.iting.chat/aioffice/custom/beite/ai.iting.aioffice-uos_1.8.2.8_amd64.deb",
          version: "1.8.2.8",
          createTime: "2024-11-25",
        };
      } else if (this.curHost == "wifi" || this.isSpecialDomain()) {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/Linux/tongxin/ai.iting.aioffice-uos_2.0.4.0_amd64.deb",
          version: "2.0.4.0",
          createTime: "2026-1-27",
        };
      } else {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/Linux/AIOffice/ai.iting.aioffice-uos_1.8.0.1_amd64.deb",
          version: "1.8.0.1",
          createTime: "2024-2-1",
        };
      }
    },

    // 统信ARM
    getDownloadTXArmUrl() {
      if (this.curHost == "beite") {
        return {
          url: "https://download.iting.chat/aioffice/custom/beite/ai.iting.aioffice-uos_1.8.2.8_arm64.deb",
          version: "1.8.2.8",
          createTime: "2024-11-25",
        };
      } else if (this.curHost == "yundesk") {
        return {
          url: "https://download.iting.chat/aioffice/aioffice/tongxin-arm/ai.iting.aioffice.uos.arm64_v11.2.3.deb",
          version: "11.2.3",
          createTime: "2025-2-28",
        };
      } else if (this.curHost == "wifi" || this.isSpecialDomain()) {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/Linux/tongxin/ai.iting.aioffice.uos.arm64_v2.0.4.0.deb",
          version: "2.0.4.0",
          createTime: "2026-1-27",
        };
      }
    },
    // 麒麟X86
    getDownloadQLUrl() {
      if (this.curHost == "m70" || this.curHost == "zuoh") {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/Linux/qilin/ai.iting.aioffice_1.8.2.3_amd64.deb",
          version: "1.8.2.3",
          createTime: "2024-8-21",
        };
      } else if (this.curHost == "yff") {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/custom/yunfeifan/ai.iting.yunfeifan-kylinos_1.8.2.3_amd64.deb",
          version: "1.8.2.3",
          createTime: "2024-8-27",
        };
      } else if (this.curHost == "tele") {
        return {
          url: " https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/Linux/qilin/ai.iting.aioffice_1.8.2.5_amd64.deb",
          version: "1.8.2.5",
          createTime: "2.24-9-12",
        };
      } else if (this.curHost == "newland") {
        return {
          url: "https://download.iting.chat/aioffice/aioffice/ai.iting.aioffice_1.8.2.6_amd64.deb",
          version: "1.8.2.6",
          createTime: "2024-10-12",
        };
      } else if (this.brandSubdomain.includes("hbs")) {
        return {
          url: "https://download.iting.chat/aioffice/aioffice/qilin-x86/ai.iting.aioffice_1.8.2.9_amd64.deb",
          version: "1.8.2.9",
          createTime: "2025-3-20",
        };
      } else if (this.curHost == "pansheng") {
        return {
          url: "https://download.iting.chat/aioffice/custom/xindaluPansheng/ai.iting.aioffice_1.8.2.7_amd64.deb",
          version: "1.8.2.7",
          createTime: "2024-10-30",
        };
      } else if (this.curHost == "sheenhan" || this.curHost == "shihan") {
        return {
          url: "https://download.iting.chat/aioffice/custom/ShiHan/ai.iting.sheenhan-kylinos_1.8.2.7_amd64.deb",
          version: "1.8.2.7",
          createTime: "2024-11-15",
        };
      } else if (this.curHost == "beite") {
        return {
          url: "https://download.iting.chat/aioffice/custom/beite/ai.iting.aioffice_1.8.2.8_amd64.deb",
          version: "1.8.2.8",
          createTime: "2024-11-25",
        };
      } else if (this.curHost == "wifi" || this.isSpecialDomain()) {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/Linux/qilin/AiOffice_kylin_7.0.3_amd64.deb",
          version: "7.0.3",
          createTime: "2026-5-26",
        };
      } else {
        return {
          url: " https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/Linux/AIOffice/ai.iting.aioffice_1.8.0.2_amd64.deb",
          version: "1.8.0.2",
          createTime: "2024-2-1",
        };
      }
    },

    // 麒麟ARM
    getDownloadQLArmUrl() {
      if (this.curHost == "yff") {
        return {
          url: "https://download.iting.chat/aioffice/custom/yunfeifan/ai.yunfeifan-kylinos-arm64-yun_2.0.1.0_arm64(1).deb",
          version: "2.0.1.0",
          createTime: "2024-11-4",
        };
      } else if (this.brandSubdomain.includes("hbs")) {
        return {
          url: "https://download.iting.chat/aioffice/aioffice/qlin-arm/ai.iting.aioffice_V1.8.3.0_KylinOS_arm64.deb",
          version: "1.8.3.0",
          createTime: "2025-3-20",
        };
      } else if (this.curHost == "beite") {
        return {
          url: "https://download.iting.chat/aioffice/custom/beite/ai.iting.aioffice-kylinos_1.8.2.8_arm64.deb",
          version: "1.8.2.8",
          createTime: "2024-11-25",
        };
      } else if (this.curHost == "yundesk") {
        return {
          url: "https://download.iting.chat/aioffice/aioffice/qlin-arm/ai.iting.aioffice_V1.8.3.0_KylinOS_arm64.deb",
          version: "1.8.3.0",
          createTime: "2025-2-28",
        };
      } else if (this.curHost == "wifi" || this.isSpecialDomain()) {
        return {
          url: "https://qjzn-app.oss-cn-hangzhou.aliyuncs.com/Linux/qilin/AiOffice_kylin_7.0.3_arm64.deb",
          version: "7.0.3",
          createTime: "2026-5-26",
        };
      }
    },
  },
};
</script>

<style>
.img-over,
.img-out {
  opacity: 0;
  transition: all 4s;
}

.img-over,
.img-out {
  opacity: 1;
  transition: all 4s;
}
</style>
